import { TradeItemType } from '../../data/types/trade-item/trade-item-type';
import { tradeItemConfigs } from './trade-item.configs';
import memoize from 'fast-memoize';

export const getTradeItemConfig = memoize(
  (tradeItemType: TradeItemType) => tradeItemConfigs[tradeItemType],
);
